import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Observable, distinctUntilChanged, filter, map } from 'rxjs';

import { Tab } from './tab';
import { TabService } from './tab.service';

@Component({
  selector: 'shrd-uic-tab-content',
  templateUrl: './tab-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabContentComponent {
  @Input() id: string;
  @Input() alwaysRenderContent = false;
  @Input() containerClass = '';

  readonly tabActive$ = this.getActive$();

  constructor(private readonly tabService: TabService) {}

  private getActive$(): Observable<{ tab: Tab; active: boolean }> {
    return this.tabService.change.pipe(
      filter(Boolean),
      map(tab => ({ active: tab.contentReference === this.id, tab })),
      distinctUntilChanged()
    );
  }
}
